module.exports = __webpack_public_path__ + "img/fangan.88c460f9.png";